// Separate file for testing purposes
import noImage from './noimage.svg?url';
export default noImage;
